import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c(VToolbar, {
    attrs: {
      color: _vm.options.color,
      dense: "",
      flat: ""
    }
  }, [_c(VToolbarTitle, {
    staticClass: "white--text"
  }, [_vm._v("Change Client Post-Order Confirmation")])], 1), _c("section", {
    staticClass: "content"
  }, [_c(VCardText, {
    staticClass: "pb-0"
  }, [_c("p", {
    staticClass: "modal-instructions"
  }, [_vm._v(" Please be aware of the following considerations before proceeding with the client change for this order: ")]), _c("ul", {
    staticClass: "considerations-list"
  }, [_c("ul", {
    staticClass: "considerations-list"
  }, [_c("li", [_vm._v("Verify and adjust shipping and billing addresses.")]), _c("li", [_vm._v("Verify and adjust payment terms as per the new client's policy.")]), _c("li", [_vm._v("Verify and adjust importer as per the new customer's location.")]), _c("li", [_vm._v(" Confirm appropriate currency and tax details based on the new client's location. ")]), _c("li", [_vm._v(" Adapt shipping type and destination according to the new client's requirements. ")]), _c("li", [_vm._v(" Ensure product availability for the new client and update the order summary if necessary. ")]), _c("li", {
    staticClass: "important-note"
  }, [_vm._v("The current payment method will be removed.")]), _c("li", {
    staticClass: "important-note"
  }, [_vm._v(" Changing the client will automatically delete any applied credit notes for this order. ")]), _c("li", {
    staticClass: "important-note"
  }, [_vm._v(" The associated financing option will be updated as per the new customer. ")]), _c("li", {
    staticClass: "important-note"
  }, [_vm._v(" The consultant's commission, if applicable, will remains unchanged. ")])])]), _vm.errorOccured ? _c("p", {
    staticClass: "errorLabel pt-4 text-center"
  }, [_vm._v(" Please ensure all fields are correctly updated before confirming the client change. ")]) : _vm._e()])], 1), _c(VCardActions, {
    staticClass: "card-actions"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      text: "",
      disabled: _vm.validating
    },
    nativeOn: {
      click: function click($event) {
        return _vm.internalCancel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.validating,
      disabled: _vm.timeLeft > 0 && !_vm.validating
    },
    nativeOn: {
      click: function click($event) {
        return _vm.confirmClientChange.apply(null, arguments);
      }
    }
  }, [_vm._v(" Confirm Client Change " + _vm._s(_vm.timeLeft > 0 ? "".concat(_vm.timeLeft, "s") : "") + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };